/* Impression SCDM — le configurateur demarre VIERGE.

   Le probleme : en arrivant sur le site, le client trouvait deja une forme, un
   materiau, un vernis et une quantite coches. Il pouvait donc commander sans
   avoir rien choisi, en croyant que c etait nous qui avions decide pour lui.

   Ce que fait ce fichier : au chargement, aucun choix n est marque. Chaque
   groupe se « reveille » au premier clic du client, et c est seulement quand les
   cinq choix sont faits que le bouton « Ajouter a ma commande » s active.
   Le laminage, lui, est facultatif : il n a jamais retenu le bouton — voir la
   note au-dessus de GROUPES.

   Comment, sans toucher a scdm.js : le moteur garde ses valeurs par defaut en
   memoire (c est ce qui fait vivre l apercu), on ne fait qu empecher l affichage
   de les presenter comme des choix du client. scdm.js reconstruit ses groupes a
   chaque rafraichissement et y remet la classe « on » : un observateur la retire
   tant que le groupe n a pas ete touche. Le clic est intercepte en phase de
   CAPTURE, donc avant le gestionnaire de scdm.js : le groupe est deja marque
   comme choisi quand la classe revient, et elle reste.

   Charge depuis snippets/scdm-minimum.liquid, qui est rendu sur toutes les
   pages ; le script sort tout seul quand il n y a pas de configurateur. */

(function () {
  'use strict';

  function texteValidation(cle, repli, params) {
    var racine = document.getElementById('scdmConfigValidationI18n');
    var texte = racine && racine.getAttribute('data-config-validation-' + cle);
    return (texte || repli).replace(/\{([a-z_]+)\}/g, function(mot, nom) {
      return params && Object.prototype.hasOwnProperty.call(params, nom) ? String(params[nom]) : mot;
    });
  }

  /* LE LAMINAGE N EST PLUS DANS CETTE LISTE — 9 septembre 2026.

     Cette liste tient les choix OBLIGATOIRES : tant qu il en manque un, le
     bouton attend et la phrase « Il reste a choisir... » nomme ce qui
     manque. Le laminage est devenu FACULTATIF (une case qu on coche ou pas)
     et sa rangee ne s affiche meme plus sur un autocollant ordinaire.

     L Y LAISSER AURAIT REFAIT LE BOUTON MUET DU 9 SEPTEMBRE : le message
     aurait reclame « le laminage » sur une rangee absente de l ecran, et le
     client n aurait eu aucun moyen de satisfaire la demande. Le bouton
     serait reste gris pour toujours. Si un jour vous remettez le laminage
     ici, verifiez d abord que sa rangee est TOUJOURS visible et qu elle
     porte un choix qu on peut faire.

     Les cinq qui restent sont les cinq sans lesquels une commande n a pas
     de sens : format, forme, matiere, vernis, quantite.

     LE VERNIS Y RESTE, MAIS SA RANGEE PEUT SE CACHER — 9 septembre 2026.
     Sur du lettrage decoupe il n y a aucune impression a vernir : scdm.js
     cache la rangee entiere (vernisOffert()). Un choix obligatoire dont la
     rangee est absente de l ecran, c est exactement le bouton muet decrit
     plus haut. On ne retire donc pas le vernis de cette liste — il redevient
     obligatoire des le retour sur un materiau imprime — mais manquants() et
     tousChoisis() SAUTENT tout groupe dont la rangee est cachee. Le filet
     vaut pour n importe quelle rangee conditionnelle a venir. */
  var GROUPES = [
    { cle: 'format',   hote: 'scdmTaille'    },
    { cle: 'forme',    hote: 'scdmFormes'    },
    { cle: 'matiere',  hote: 'scdmMatieres'  },
    { cle: 'finition', hote: 'scdmFinitions' },
    { cle: 'quantite', hote: 'scdmQtes'      }
  ];

  var NOMS = {
    format: 'le format',
    forme: 'la forme de découpe',
    matiere: 'le matériau',
    finition: 'le vernis',
    quantite: 'la quantité'
  };

  var TEXTE_PLACEHOLDER = '— Choisissez un format —';
  /* Le site le dit lui meme au-dessus du depot de fichier : « Pas de visuel ?
     Prenez un modele pret a imprimer plus bas. » Aucun materiau ne se commande
     sans image : meme le lettrage decoupe est taille dans le fichier du client.
     Une commande sans visuel est donc un choix manquant comme les autres. */
  var TEXTE_VISUEL = 'Il reste à fournir un fichier ou à choisir un modèle.';

  var vierge = {};
  var observateurs = {};
  var msg = null;
  var visuelRequis = false;
  var dernierVisuel = null;
  var enCorrection = false;

  /* Un visuel est present si le moteur tient une image (fichier televerse OU
     modele pris dans le catalogue) ou si le champ de fichier porte un fichier. */
  function visuelPresent() {
    var e = (window.SCDM && window.SCDM.etat) || {};
    if (e.img) return true;
    if (e.fichier) return true;
    var f = document.getElementById('scdmFichier');
    if (f && f.files && f.files.length) return true;
    return false;
  }

  /* Une page sans depot de fichier ne doit JAMAIS bloquer le bouton. */
  function visuelManque() {
    return visuelRequis && !visuelPresent();
  }

  /* UNE RANGEE CACHEE NE SE RECLAME PAS. scdm.js cache une rangee
     conditionnelle en posant hidden ET display:none sur le .fld qui porte le
     libelle et les cases — c est ce qu il fait du vernis sur du lettrage
     decoupe, du laminage sous 144 po2, de la couleur du vinyle hors lettrage.
     Tant que la rangee est cachee, le choix ne peut pas etre fait : le nommer
     dans « Il reste a choisir... » laisserait le client devant une demande
     qu il n a aucun moyen de satisfaire, et le bouton resterait gris pour
     toujours. C est le defaut du 9 septembre, et c est le seul endroit ou il
     se rattrape.

     ON NE MARQUE PAS LE GROUPE COMME CHOISI POUR AUTANT : on le saute, le
     temps que la rangee soit cachee. Il redevient obligatoire, et de nouveau
     nomme, des que scdm.js la rouvre. */
  function groupeVisible(cle) {
    var g = null;
    for (var i = 0; i < GROUPES.length; i++) { if (GROUPES[i].cle === cle) g = GROUPES[i]; }
    if (!g) return false;
    var hote = document.getElementById(g.hote);
    if (!hote) return false;
    var n = (hote.closest && hote.closest('.fld')) || hote;
    while (n && n.nodeType === 1) {
      if (n.hidden) return false;
      if (n.style && n.style.display === 'none') return false;
      if (n.id === 'scdmConfig') break;
      n = n.parentElement;
    }
    return true;
  }

  function tousChoisis() {
    for (var i = 0; i < GROUPES.length; i++) {
      if (vierge[GROUPES[i].cle] && groupeVisible(GROUPES[i].cle)) return false;
    }
    if (visuelManque()) return false;
    return true;
  }

  /* Les CLES des groupes encore vides, dans l ordre de GROUPES. C est la
     detection elle-meme ; manquants(), juste en dessous, n en est plus que la
     traduction en francais. Une seule liste, un seul predicat : impossible que
     les deux se contredisent un jour. */
  function manquantsCles() {
    var l = [];
    GROUPES.forEach(function (g) {
      if (vierge[g.cle] && groupeVisible(g.cle)) l.push(g.cle);
    });
    return l;
  }

  function manquants() {
    return manquantsCles().map(function (cle) { return texteValidation('group_' + cle, NOMS[cle]); });
  }

  /* ------------------------------------------------------- pont de lecture

     POSE LE 10 SEPTEMBRE 2026 (tache 224). Le fichier
     assets/scdm-configurateur-clarte.js pose un marqueur discret sur le ou les
     GROUPES encore vides, a la hauteur du champ concerne. Il a donc besoin de
     savoir lesquels manquent — et il ne doit surtout pas le recalculer de son
     cote : deux detections finiraient par diverger, et le client verrait un
     champ marque en rouge alors que le bouton s active, ou l inverse.

     CE PONT EST EN LECTURE SEULE. Il ne rend que des copies : la liste
     GROUPES, l objet vierge et les observateurs restent la propriete de ce
     fichier. Rien de ce qui est publie ici ne permet de marquer un groupe
     comme choisi, d en ajouter un, ni d en retirer un. La liste des choix
     obligatoires n a pas bouge d une ligne. */
  window.SCDM_VIERGE = {
    groupes: function () {
      return GROUPES.map(function (g) {
        return { cle: g.cle, hote: g.hote, nom: texteValidation('group_' + g.cle, NOMS[g.cle]) };
      });
    },
    manquantsCles: manquantsCles,
    manquants: manquants,
    groupeVisible: groupeVisible
  };

  /* ---------------------------------------------------------------- style */

  function style() {
    if (document.getElementById('scdmViergeStyle')) return;
    var s = document.createElement('style');
    s.id = 'scdmViergeStyle';
    s.textContent = [
      '.scdm .scdm-manque{margin:10px 0 0;font-size:12.5px;line-height:1.45;color:var(--or,#FF7A18)}',
      '.scdm .scdm-attente{opacity:.5;cursor:not-allowed;filter:grayscale(.6)}',
      '.scdm #scdmCotes.scdm-muet{visibility:hidden}'
    ].join('\n');
    document.head.appendChild(s);
  }

  /* ------------------------------------------------- groupes a boutons */

  function nettoyer(hote) {
    var on = hote.querySelectorAll('.on');
    for (var i = 0; i < on.length; i++) on[i].classList.remove('on');
  }

  /* La quantite exacte est reecrite par scdm.js a chaque rafraichissement :
     on la revide tant que le client n a pas choisi sa quantite. */
  function viderQuantite() {
    if (!vierge.quantite) return;
    var q = document.getElementById('scdmQteExacte');
    if (q && q.value !== '') q.value = '';
  }

  function surveiller(cle, hote) {
    nettoyer(hote);
    viderQuantite();
    var o = new MutationObserver(function () {
      if (!vierge[cle]) return;
      nettoyer(hote);
      viderQuantite();
    });
    o.observe(hote, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    observateurs[cle] = o;
  }

  /* ------------------------------------------------------- liste deroulante */

  function placeholder(sel) {
    var o = sel.querySelector('option[value=""]');
    if (!o) {
      o = document.createElement('option');
      o.value = '';
      o.textContent = texteValidation('choose_format', TEXTE_PLACEHOLDER);
      sel.insertBefore(o, sel.firstChild);
    }
    /* On NE declenche PAS d evenement : le moteur garde son format en memoire,
       donc l apercu reste coherent. Seul l affichage attend le client. */
    sel.value = '';
    var cotes = document.getElementById('scdmCotes');
    if (cotes) cotes.classList.add('scdm-muet');
  }

  function surveillerSelect(sel) {
    placeholder(sel);
    var o = new MutationObserver(function () {
      if (!vierge.format) return;
      placeholder(sel);
    });
    o.observe(sel, { childList: true });
    observateurs.format = o;
  }

  /* ------------------------------------------------------------- choix fait */

  function choisi(cle) {
    if (!vierge[cle]) return;
    vierge[cle] = false;
    if (observateurs[cle]) { observateurs[cle].disconnect(); delete observateurs[cle]; }

    if (cle === 'format') {
      var sel = document.getElementById('scdmTaille');
      var vide = sel && sel.querySelector('option[value=""]');
      if (vide) vide.parentNode.removeChild(vide);
      var cotes = document.getElementById('scdmCotes');
      if (cotes) cotes.classList.remove('scdm-muet');
    }
    peindre();
  }

  /* ------------------------------------------------------- bouton d ajout */

  function peindre() {
    var b = document.getElementById('scdmAjouter');
    if (!b) return;
    /* LE PARAGRAPHE A PU ETRE EMPORTE PAR UN REDESSIN. On le reconstruit
       plutot que d ecrire dans un noeud detache — sinon le bouton reste
       bloque et la phrase « Il reste a choisir... » parle dans le vide. */
    if (msg && !document.body.contains(msg)) msg = null;
    var reste = manquants();
    var sansVisuel = visuelManque();
    dernierVisuel = !sansVisuel;

    if (!reste.length && !sansVisuel) {
      b.classList.remove('scdm-attente');
      b.removeAttribute('aria-disabled');
      if (msg) { if (msg.parentNode) msg.parentNode.removeChild(msg); msg = null; }
      return;
    }

    b.classList.add('scdm-attente');
    b.setAttribute('aria-disabled', 'true');

    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'scdm-manque';
      msg.setAttribute('role', 'status');
      b.parentNode.insertBefore(msg, b.nextSibling);
    }
    var phrases = [];
    if (reste.length) {
      phrases.push(reste.length === 1
        ? texteValidation('choose_one', 'Il reste à choisir {choice}.', { choice: reste[0] })
        : texteValidation('choose_many', 'Il reste à choisir {choices} et {last}.', { choices: reste.slice(0, -1).join(', '), last: reste[reste.length - 1] }));
    }
    if (sansVisuel) phrases.push(texteValidation('missing_artwork', TEXTE_VISUEL));
    msg.textContent = phrases.join(' ');
  }

  /* --------------------------------------------------------------- quantite */

  function bornes() {
    var d = window.SCDM_DATA || {};
    var min = parseInt(d.QTE_MIN, 10);
    if (!isFinite(min) || min < 1) min = 1;
    var max = parseInt(d.QTE_MAX, 10);
    if (!isFinite(max) || max < min) max = 0;
    return { min: min, max: max };
  }

  /* Le champ doit montrer ce qui sera reellement commande : 0 devient 1. On ne
     corrige qu a la sortie du champ, jamais pendant la frappe, sinon le client
     qui efface pour retaper voit un « 1 » lui sauter dans les doigts. Un champ
     vide reste vide : c est une frappe en cours, pas une quantite. */
  function bornerQuantite() {
    if (enCorrection) return;
    var q = document.getElementById('scdmQteExacte');
    if (!q) return;
    var brut = String(q.value).trim();
    if (brut === '') return;
    var b = bornes();
    var v = parseInt(brut, 10);
    if (!isFinite(v) || v < b.min) v = b.min;
    if (b.max && v > b.max) v = b.max;
    if (String(v) === brut) return;
    enCorrection = true;
    q.value = String(v);
    try {
      q.dispatchEvent(new Event('input', { bubbles: true }));
      q.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
    enCorrection = false;
    choisi('quantite');
  }

  /* ------------------------------------------------------------- demarrage */

  function demarrer() {
    var config = document.getElementById('scdmConfig');
    if (!config) return;

    style();
    GROUPES.forEach(function (g) { vierge[g.cle] = true; });

    GROUPES.forEach(function (g) {
      var hote = document.getElementById(g.hote);
      if (!hote) { vierge[g.cle] = false; return; }

      if (hote.tagName === 'SELECT') {
        surveillerSelect(hote);
        hote.addEventListener('change', function () {
          if (hote.value !== '') choisi('format');
        }, true);
        return;
      }

      surveiller(g.cle, hote);
      /* Un groupe sans rien a cliquer ne doit JAMAIS bloquer le bouton. */
      (function (cle, h) {
        setTimeout(function () {
          if (vierge[cle] && !h.querySelector('.opt, .qtile, [data-champ]')) choisi(cle);
        }, 3000);
      })(g.cle, hote);
      /* CAPTURE : on marque le groupe comme choisi AVANT que scdm.js ne pose
         sa classe, sinon l observateur la retirerait aussitot. */
      hote.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.opt, .qtile')) choisi(g.cle);
      }, true);
    });

    var qe = document.getElementById('scdmQteExacte');
    if (qe) {
      qe.addEventListener('input', function () {
        if (qe.value.trim() !== '') choisi('quantite');
      }, true);
      qe.addEventListener('blur', bornerQuantite);
      qe.addEventListener('change', bornerQuantite);
    }

    /* UNE RANGEE PEUT APPARAITRE OU DISPARAITRE SOUS LE CLIENT — le vernis
       quand il prend du lettrage decoupe, le laminage quand il change de
       format. Le message et le bouton doivent suivre le meme tour. On repeint
       apres chaque clic dans le configurateur (en BULLE, donc apres que
       scdm.js ait redessine ses rangees), et un filet de securite relit la
       liste quatre fois par seconde pour les changements qui ne viennent pas
       d un clic — une taille tapee au clavier, un modele pris au catalogue. */
    config.addEventListener('click', function () { setTimeout(peindre, 0); }, false);
    var dernierManque = manquants().join('|');
    setInterval(function () {
      var m = manquants().join('|');
      if (m === dernierManque) return;
      dernierManque = m;
      peindre();
    }, 250);

    var fi = document.getElementById('scdmFichier');
    visuelRequis = !!fi;
    if (fi) fi.addEventListener('change', function () { setTimeout(peindre, 60); });

    /* Le visuel peut arriver plus tard, et par deux chemins qui n annoncent
       rien de commun : televersement, ou modele pris dans le catalogue. On
       relit donc l etat, et on ne repeint que lorsqu il a change. */
    if (visuelRequis) {
      setInterval(function () {
        if (visuelPresent() !== dernierVisuel) peindre();
      }, 400);
    }

    /* Tant qu il manque un choix, le bouton ne fait rien : on arrete le clic
       avant qu il n atteigne le gestionnaire de scdm.js. */
    var b = document.getElementById('scdmAjouter');
    if (b) {
      b.addEventListener('click', function (e) {
        if (tousChoisis()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        peindre();
        if (msg && msg.scrollIntoView) msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }

    peindre();
  }

  function quandPret(n) {
    if (document.getElementById('scdmConfig') && window.SCDM && window.SCDM.etat) return demarrer();
    if ((n || 0) > 60) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
